//@ts-nocheck
import {
  styled,
  $fontWeightLight,
  $fontSize,
} from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import { Flex } from "@acko-tech/building-blocks.ui.common";

export const Container = styled.div`
  border: 1px solid #e7e7f0;
  border-radius: 8px;
  padding: 24px 16px 16px 16px;
  background: #f8f7fc;
  color: #040222;
`;

export const Label = styled(Text)`
  font-weight: ${$fontWeightLight};
  font-size: ${$fontSize.xxs};
  line-height: 18px;
  letter-spacing: 0.04em;
  display: inline-block;
  background-color: white;
  padding: 0 5px;
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(0.8em, -0.6em);
  color: ${(props) => (props.focused ? "#4f34d2" : "#5B5675")};
`;

export const Wrapper = styled.div`
  position: relative;
  margin-top: ${(props) => (props.isDesktop ? "1.875rem" : "1.5rem")};
  width: 100%;
  ${(props) => props.styles}
`;

export const Note = styled(Text)`
  color: #5b5675;
  padding: 8px 0 0 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`;

// export const InputContainer = styled.div`
//   position: relative;
//   width: 100%;
// `;

export const Name = styled(Flex)`
  flex-direction: column;
  align-item: flex-start;
  font-size: 14px;
  font-weight: 500;
  color: #5b5675;
`;

export const PersonalDetails = styled(Flex)`
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #5b5675;
`;
